import TalentFAQ from "./TalentFAQ.vue"

export default function install(Vue) {
  Vue.component(TalentFAQ.name, TalentFAQ)
}
